// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"4508020966957179692e","655":"79baac627e8f10abb6b1"}[chunkId] + ".js";
};